const EInvoicingFieldRefEnum = Object.freeze({
    ENTERSOFT_INVOICE_URL: 'ENTERSOFT_INVOICE_URL',

    ENTERSOFT_INVOICE_STATUS: 'ENTERSOFT_INVOICE_STATUS',

    ENTERSOFT_CREDIT_NOTE_URL: 'ENTERSOFT_CREDIT_NOTE_URL',

    ENTERSOFT_CREDIT_NOTE_STATUS: 'ENTERSOFT_CREDIT_NOTE_STATUS',

    ENTERSOFT_METADATA: 'ENTERSOFT_METADATA',
});

module.exports = EInvoicingFieldRefEnum;
